import { Component, EventEmitter, Input, Output, output, signal } from '@angular/core';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss'
})
export class SearchFieldComponent {

  @Input() label= 'Common.Search'
  @Output() onSearch: EventEmitter<any> = new EventEmitter();
  
  search(event:any){
    this.onSearch.emit(event)
  }
}
